export default __webpack_public_path__ + "dist/media/Cancel.b8f38ef1.svg";